import * as React from 'react';
import * as _ from 'lodash';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchPostsWP } from '../actions/posts';
import { fetchCategoriesStoreWP } from '../actions/categories';
import mapStateToProps from '../utils/mapStateToProps';
import mapDispatchToProps from '../utils/mapDispatchToProps';
import { getCookie } from '../helpers/index';

class Products extends React.Component<any, any> {

	constructor(props: any) {
		super(props);
		this.state = {
			loading: true,
			posts: [],
			active_all: 0
		}
	}

	componentDidMount() {
		this.props.fetchPostsWP({
			number: 100,
			orderby: 'date',
			order: 'desc',
			post_type: 'grocery'
		});
		this.props.fetchCategoriesStoreWP({
			term: 'grocery_categories',
			number: 100
		});
		document.title = this.props.t('products');
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.postsWP.loading == false && nextProps.categoriesStoreWP.loading == false) {
			this.setState({
				loading: false,
				posts: nextProps.postsWP.data
			})
		}
	}

	shouldComponentUpdate(nextProps) {
		if (nextProps.postsWP.loading || nextProps.categoriesStoreWP.loading) {
			return false;
		} else {
			return true;
		}
	}

	allProduct = () => {
		this.setState({
			active_all: 0,
			posts: this.props.postsWP.data
		});
	};

	filterCate = (term) => {
		var data_categories = _.filter(this.props.postsWP.data, function (post) {
			return _.some(post.terms, { 'term_id': term, 'taxonomy': 'grocery_categories' });
		});

		this.setState({
			active_all: term,
			posts: data_categories
		});
	};

	render() {

		const { categoriesStoreWP, t } = this.props;
		const { posts, active_all } = this.state;

		var language = 'vn';

		if(getCookie('language_landing')) {
			language = getCookie('language_landing');
		}

		var filteredProduct = _.filter(posts, function (post) {
			return _.some(post.custom_fields, { 'value': language, 'key': 'language' });
		});

		var products_div = filteredProduct.map(item => {
			return (
				<div key={item.post_id} className="col-6 col-sm-4">
					<div className="itemProducts">
						<Link to={`/grocery/${item.post_id}/${item.post_name}`}>
			                  <span className="imgPrd">
			                    <img src={require('../img/img-maskPrd.png')}
			                         style={{ background: `url(${item.post_thumbnail.link}) no-repeat center center/cover` }}/>
			                  </span>
							<h2 className="itemTitle">{item.post_title}</h2>
						</Link>
					</div>
				</div>
			);
		});

		var filteredList = _.filter(categoriesStoreWP.data, function (post) {
			return _.some(post.custom_fields, { 'value': language, 'key': 'language' });
		});

		var cate_name = filteredList.map(item => {
			var active = 'catItem';
			if (active_all == item.term_id) {
				active = 'catItem active';
			}
			return (
				<li key={item.term_id} onClick={() => this.filterCate(item.term_id)} className={active}>
					<a href="JavaScript:Void(0);">{item.name}</a></li>
			);
		});

		return (
			<div className="productsWrap">
				<div className="container">
					<div className="pageTitle">
						{t('grocery')}
					</div>
					<div className="row">
						<div className="col-sm-3">
							<div className="sidebarProduct">
								<ul className="product-categories">
									<li onClick={this.allProduct}
									    className={active_all == 0 ? 'catItem active' : 'catItem'}>
										<a href="JavaScript:Void(0);">All</a></li>
									{cate_name}
								</ul>
							</div>
						</div>
						<div className="col-sm-9">
							<div className="shopProducts">
								<div className="row">
									{products_div}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div id="loading-data"></div>
				{this.state.loading ? <div className="loadingPage active"> <img src={require('../img/Spin-1s-58px.gif')}/></div> : '' }
			</div>
		);
	}
}

export default connect(mapStateToProps([
	'postsWP', 'categoriesStoreWP'
]), mapDispatchToProps({
	fetchPostsWP, fetchCategoriesStoreWP
}))(translate('translations')(Products));



// WEBPACK FOOTER //
// ./src/containers/Grocerys.tsx